import { Component, OnInit, Input, forwardRef, Output, EventEmitter, ViewChild, Optional, Inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NgModel, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { ElementBase } from '../base/element-base';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent extends ElementBase<boolean> {

  @Input()
  title: string;

  @Input()
  name: string;

  @Output()
  checkboxClick = new EventEmitter();

  @Output()
  checkboxChanged = new EventEmitter();

  @ViewChild(NgModel, {static: true}) model: NgModel;

  @Input()
  textInTop: boolean;

  onClick($event) {
    this.checkboxClick.emit($event);
  }

  checkedChanged($event) {
    this.checkboxChanged.emit($event);
  }

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
  ) {
    super(validators, asyncValidators);
  }

  writeValue(value: boolean): void {
    if (this.value !== value) {
      this.value = value;
      this.checkboxChanged.emit(value);
    }
  }
}
